import Vue from 'vue'

let baseUrl = '/apiv1/organization'

/**
 * 获取子级节点
 * @param {*} params
 */
export const getChildren = (params) => {
  Vue.fetch.post(`${baseUrl}/query/children`, params)
}

/**
 * 获取所有的子级节点
 * @param {*} params
 */
export const getAllChildren = (params) => {
  return Vue.fetch.post(`${baseUrl}/query/allChildren`, params)
}

/**
 * 添加部门
 * @param {*} params
 */
export const add = (params) => {
  return Vue.fetch.post(`${baseUrl}/add`, params)
}

/**
 * 更新部门
 * @param {*} params
 */
export const update = (params) => {
  return Vue.fetch.post(`${baseUrl}/update`, params)
}

/**
 * 删除部门
 * @param {*} params
 */
export const remove = (params) => {
  return Vue.fetch.post(`${baseUrl}/remove`, params)
}

/**
 *  从部门内移除员工
 * @param {*} params
 */
export const removeUserFromDept = (params) => {
  return Vue.fetch.post(`${baseUrl}/user/remove`, params)
}

/**
 *  从部门内添加员工
 * @param {*} params
 */
export const addUserToDept = (params) => {
  return Vue.fetch.post(`${baseUrl}/user/add`, params)
}

/**
 *  部门添加员工
 * @param {*} params
 */
export const addUserFromDepartment = (params) => {
  return Vue.fetch.post(`${baseUrl}/user/add`, params)
}



// WEBPACK FOOTER //
// ./src/cdpBase/services/organization.js